import { useCallback, useState } from "react";
import { LoadingSpinner } from "../../../components/ui/loadingSpinner/loadingSpinner";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { useTemplatesV2 } from "../../../hooks/useTemplatesV2";
import { schemaWithEmailValidator } from "../../../models/schemasV2";
import { z } from "zod";
import { fetchFastApi } from "../../../api/fastapi";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import { formattedDate } from "../../../lib/utils";

export const TemplatesV2Page = () => {
  const { loading: loadingSchemas, schemas } = useTemplatesV2({
    fetchOnLoad: true,
  });
  const [loadingCreateSchema, setLoadingCreateSchema] = useState(false);
  const navigate = useNavigate();

  const createNewTemplate = useCallback(async () => {
    setLoadingCreateSchema(true);
    try {
      const response = await fetchFastApi({
        path: "/schemas/v2/schema/create",
        method: "POST",
      });
      const { schema_id } = await response;
      if (schema_id) {
        navigate(`/dashboard/templates/v2/${schema_id}`);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingCreateSchema(false);
  }, [navigate]);

  return (
    <div className="h-screen flex flex-col w-full mx-auto">
      <div className="px-4 mx-auto flex flex-col w-full max-w-4xl mt-24">
        <div className="flex justify-between items-center">
          <div className="text-2xl">Extraction Templates</div>
          <Button onClick={createNewTemplate} loading={loadingCreateSchema}>
            Create New Template
          </Button>
        </div>

        <div className="mt-8 max-h-[75vh] overflow-auto">
          {loadingSchemas ? (
            <div className="flex justify-center items-center h-64">
              <LoadingSpinner />
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Created By</TableHead>
                  <TableHead>Created At</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {schemas.map((schema) => (
                  <TemplateRow key={schema.id} schema={schema} />
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};

interface TemplateRowProps {
  schema: z.infer<typeof schemaWithEmailValidator>;
}

const TemplateRow = ({ schema }: TemplateRowProps) => {
  const navigate = useNavigate();

  const onRowClick = useCallback(() => {
    navigate(`/dashboard/templates/v2/${schema.id}`);
  }, [navigate, schema.id]);
  return (
    <TableRow
      className="cursor-pointer"
      onClick={onRowClick}
      role="button"
      tabIndex={0}
    >
      <TableCell>{schema.name}</TableCell>
      <TableCell>{schema.email}</TableCell>
      <TableCell>{formattedDate(schema.createdAt)}</TableCell>
    </TableRow>
  );
};
